import Vue from 'vue';
import axios from 'axios';
import VueMeta from 'vue-meta';

// composition api should be the first installed plugin
// if not some conflicts may happen, this is fixed on vue-3
import './config';

import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.use(VueMeta);

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
// axios.defaults.headers.common = { 'public-key': process.env.VUE_APP_PUBLIC_KEY };

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
